import type { FaireProductEntity } from "../../entity_types/product";

export const p_s72sderftp: FaireProductEntity = {
  token: "p_s72sderftp",
  type: "product",
  name: "CHUNKY KNIT MULTI STRIPED OVERSIZED SWEATER TOP",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/db9b14904f8307fb0cac9f86d8ef1970cad34bee26aef3ba2a80573f8a6aa344.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/426692365384a5df3e9914b5742ca9fd0dd0cdf6acffbb0873e29c94c0485219.jpeg",
    "https://cdn.faire.com/fastly/c0f08e18d41e4ae6cc31a45a4b234d40cff4875169f9752d6ea37a5b4ed92ad9.jpeg",
    "https://cdn.faire.com/fastly/928c678584a65f23bc80826a8a3d25fe0994787bdcc8926dc85e2dddc666a45a.jpeg",
    "https://cdn.faire.com/fastly/88501418789abfa202b8bd28e00ff438a6fa39737f55149823f9560de3eeeed6.jpeg",
    "https://cdn.faire.com/fastly/80b1c934b3a05f30e5c17372444f3731c94e7396d328fb17bf13748b3ec9e849.jpeg",
    "https://cdn.faire.com/fastly/a5ecfb21a86f4f967a3617fc7345331f575a7d2edeb549aa0d60fe30247083f3.jpeg",
    "https://cdn.faire.com/fastly/21094e16c6117d8915a438919b652f7329e5a39b00adaf04fc2708b7afc714b4.jpeg",
  ],
  priceDollars: 174,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:11.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
